/**
 * Shared helpers for units management
 */

import { supabase } from '@/lib/integrations/supabase'

export function isNotFoundLike(error: any): boolean {
  // Supabase can return "PGRST116" for single() not found, etc.
  const msg = (error?.message || '').toLowerCase()
  return msg.includes('no rows') || msg.includes('not found') || error?.code === 'PGRST116'
}

export async function getAuthUser() {
  const { data, error } = await supabase.auth.getUser()
  if (error) throw error
  return data.user
}

// IMPORTANT: adjust this if your profiles table uses "id" instead of "user_id"
export const PROFILES_USER_ID_COL = 'user_id' as const
